import { Dispatch, SetStateAction, useCallback } from 'react';
import Form from 'src/lib/forms/Form';

type UseFormFieldsEventHandlersParams = {
	formState: Form,
	setFormState: Dispatch<SetStateAction<Form>>,
	setEditedFields: Dispatch<SetStateAction<Record<string, boolean>>>
};

const useFormFieldsEventHandlers = ( {
	formState, setFormState, setEditedFields
}: UseFormFieldsEventHandlersParams ) => {
	const onFieldChange = useCallback( ( field: string, value: unknown ) => {
		setFormState( prevState => prevState.set( field, value ) );
		setEditedFields( prevState => ( {
			...prevState,
			[ field ]: false
		} ) );
	}, [] );

	const onFieldBlur = useCallback( ( field: string ) => {
		if ( !formState.data[ field ] ) { return; }
		setEditedFields( prevState => ( {
			...prevState,
			[ field ]: true
		} ) );
	}, [ formState ] );

	const onNameInputBlur = useCallback( () => onFieldBlur( 'name' ), [] );
	const onClientNameInputBlur = useCallback( () => onFieldBlur( 'clientName' ), [] );

	const onNameInputChange = useCallback( ( value: string ) => onFieldChange( 'name', value ), [] );
	const onClientNameInputChange = useCallback( ( value: string ) => onFieldChange( 'clientName', value ), [] );
	const onStartAtChange = useCallback( ( value: string ) => onFieldChange( 'startDate', value ), [] );
	const onDueDateChange = useCallback( ( value: string ) => onFieldChange( 'dueDate', value ), [] );
	const onWorkspaceSelectChange = useCallback( ( value: string ) => {
		if ( formState.data.workspaceID === value ) { return; }

		onFieldChange( 'workspaceID', value );
		onFieldChange( 'inviteAllMembers', false );
		onFieldChange( 'inviteContactGroups', [] );
	}, [ formState.data.workspaceID, onFieldChange ] );
	const onAssetsStartRetouchedSelectChange = useCallback(
		( value: string ) => onFieldChange( 'assetsStartRetouched', value === 'true' ), [ onFieldChange ]
	);
	const onInviteAllMembersChange = useCallback(
		( event: React.ChangeEvent<HTMLInputElement> ) => onFieldChange( 'inviteAllMembers', event.target.checked ), [ onFieldChange ]
	);

	return {
		onNameInputBlur,
		onClientNameInputBlur,
		onNameInputChange,
		onClientNameInputChange,
		onStartAtChange,
		onDueDateChange,
		onWorkspaceSelectChange,
		onAssetsStartRetouchedSelectChange,
		onInviteAllMembersChange
	};
};

export default useFormFieldsEventHandlers;
